"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconSearch = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M60.85 57.46L47.35 44l.54-.7a21.85 21.85 0 0 0 4.61-13.48 22.13 22.13 0 1 0-10 18.5l.68-.44L56.81 61.5a2.93 2.93 0 0 0 4 0 2.86 2.86 0 0 0 .04-4.04zM30.4 46.15a16.37 16.37 0 1 1 16.37-16.37A16.39 16.39 0 0 1 30.4 46.15z"
  })),
  height: undefined,
  width: undefined
});
IconSearch.displayName = 'IconSearch';
var _default = IconSearch;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/search.js
// module id = 593
// module chunks = 0